import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5ce37644"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info-box"
}, " Set up your advertising budget strategy for a selected time period. Choose between a fixed allocation or a variable budget based on your revenue. ", -1));
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "type-title"
};
const _hoisted_4 = {
  class: "d-flex w-full date"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " - ", -1));
const _hoisted_6 = {
  class: "type-box"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "type-title"
}, " Decide how your advertising budget will be calculated ", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_WrapWithInfo = _resolveComponent("WrapWithInfo");
  const _component_DateValue = _resolveComponent("DateValue");
  const _component_AppIcon = _resolveComponent("AppIcon");
  const _component_FlexRow = _resolveComponent("FlexRow");
  const _component_ppc_strategies_dates_modal = _resolveComponent("ppc-strategies-dates-modal");
  const _component_dropdown_body = _resolveComponent("dropdown-body");
  const _component_b_dropdown = _resolveComponent("b-dropdown");
  const _component_FlexColumn = _resolveComponent("FlexColumn");
  const _component_PpcStrategiesModalAllocation = _resolveComponent("PpcStrategiesModalAllocation");
  const _component_right_pane_layout = _resolveComponent("right-pane-layout");
  const _component_ppc_strategies_confirm_update_modal = _resolveComponent("ppc-strategies-confirm-update-modal");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_right_pane_layout, {
    modelValue: $options.modal,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $options.modal = $event),
    onSubmit: $options.onSubmit,
    isCreatable: $data.isValid
  }, {
    title: _withCtx(() => [_createTextVNode(_toDisplayString(`${$props.isEdit ? "Edit" : "Create"} strategy`), 1)]),
    ok: _withCtx(() => [_createTextVNode(_toDisplayString(`${$props.isEdit ? "Edit" : "Create"}`), 1)]),
    default: _withCtx(() => [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createVNode(_component_FlexColumn, {
      gap: 8,
      class: "strategy-selector cursor-pointer",
      onClick: $options.onDateModalVisible
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_WrapWithInfo, {
        info: "\n          Choose the timeframe for your budget strategy. \n          Budget strategies should cover full weeks from Monday to Sunday, \n          as budget reallocation among campaigns is done every Monday.\n          "
      }, {
        default: _withCtx(() => [_createTextVNode(" Select strategy period ")]),
        _: 1
      })]), _createVNode(_component_b_dropdown, {
        ref: "calendarDropdown",
        "no-caret": "",
        toggleClass: "selector",
        onShown: $options.handleShown
      }, {
        "button-content": _withCtx(() => [_createVNode(_component_FlexRow, {
          gap: 12,
          style: {
            justifyContent: 'flex-start',
            padding: '16px',
            border: '1px solid #E3E3E3',
            borderRadius: '8px',
            fontWeight: '500',
            fontSize: '14px',
            lineHeight: '19.6px'
          }
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_DateValue, {
            styles: {
              padding: 0
            },
            value: $data.startWeek,
            format: `D MMM`
          }, null, 8, ["value"]), _hoisted_5, _createVNode(_component_DateValue, {
            styles: {
              padding: 0
            },
            value: $data.endWeek,
            format: `D MMM YYYY`
          }, null, 8, ["value"])]), _createVNode(_component_AppIcon, {
            icon: "calendar",
            color: "#616161"
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_dropdown_body, null, {
          default: _withCtx(() => [_createVNode(_component_ppc_strategies_dates_modal, {
            onClose: $options.closeDropdown,
            ref: "calendar",
            start: $data.startWeek,
            end: $data.endWeek,
            weeksRange: _ctx.weeksRange,
            onSubmit: $options.handleDateSubmit
          }, null, 8, ["onClose", "start", "end", "weeksRange", "onSubmit"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["onShown"])]),
      _: 1
    }, 8, ["onClick"]), _createElementVNode("div", _hoisted_6, [_hoisted_7, $options.computedWeeks ? (_openBlock(), _createBlock(_component_PpcStrategiesModalAllocation, {
      key: 0,
      title: "Fixed",
      value: $data.valueAmount,
      type: "fixed",
      method: $data.allocationMethod,
      info: "Allocate a budget amount for the selected period. \n        The weekly budget available will be calculated\n         based on the spend and the remaining number of weeks.",
      label: "Allocation",
      afterLabel: "This amount will be divided equally across each week.",
      onSelect: $options.onAllocationMethodChange,
      onInput: _cache[0] || (_cache[0] = val => $data.valueAmount = val),
      currencyCode: $props.currency,
      onValid: $options.handleValidValue,
      validateRule: $options.getInputValidationRuleForCurrency(),
      weeks: $options.computedWeeks
    }, {
      prepend: _withCtx(() => [_createTextVNode(_toDisplayString($options.getCurrencySymbol($props.currency)), 1)]),
      default: _withCtx(() => [_createTextVNode(" > ")]),
      _: 1
    }, 8, ["value", "method", "onSelect", "currencyCode", "onValid", "validateRule", "weeks"])) : _createCommentVNode("", true), _createVNode(_component_PpcStrategiesModalAllocation, {
      title: "Variable: % of sales",
      value: $data.valuePercent,
      type: "variable",
      label: "% of amount",
      afterLabel: "Specify the \n        percentage of last week's revenue to allocate \n        for advertising budget.",
      info: "Set your weekly budget as a percentage of your past sales.\n         This allows for dynamic budgeting based on performance.",
      step: 0.01,
      method: $data.allocationMethod,
      onSelect: $options.onAllocationMethodChange,
      onInput: _cache[1] || (_cache[1] = val => $data.valuePercent = val),
      onValid: $options.handleValidValue,
      validateRule: "strategies_percentage"
    }, {
      append: _withCtx(() => [_createTextVNode(" % ")]),
      _: 1
    }, 8, ["value", "method", "onSelect", "onValid"])])])]),
    _: 1
  }, 8, ["modelValue", "onSubmit", "isCreatable"]), _createVNode(_component_ppc_strategies_confirm_update_modal, {
    modelValue: $data.confirmUpdateModal,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.confirmUpdateModal = $event),
    onUpdate: $options.handleUpdateConfirmed,
    onCancel: $options.handleUpdateRejected
  }, null, 8, ["modelValue", "onUpdate", "onCancel"])], 64);
}